import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
/* import { Button } from "antd"; */
import { Modal, Button } from 'react-bootstrap';
import { InputGroup } from 'react-bootstrap';

const ViewPSi = (props) => {
  const history = useHistory();

  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  // const [psiComments,setIfComments] = useState(ls.get('psiComments'));
  // const [option,setOption] = useState(ls.get('option'))
  const [psiComments, setIfComments] = useState(props.psiAmt);
  const [option, setOption] = useState(props.psiId);
  const successData = useSelector(state => state.LoginReducer.payload);

  const [optionError, setPositionError] = useState("");

  const [ifCommentsError, setCommentsError] = useState("");
  const adminData = useSelector(state => state.LoginReducer.payload);
  const [togglePopupOpen, setTogglePopupOpen] = useState(true);
  const [notesList, setNotesList] = useState("");

  const [value, setValue] = useState("");
  const [drop, setDrop] = useState("");

  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }




  console.log("valuePsi======", psiComments)
  console.log("valueOption======", option)

  const saveAdd = () => {

    setCommentsError("")
    setPositionError("")

    if (!option) {
      setPositionError("Option is required")
      return;
    }

    if (!psiComments) {
      setCommentsError("Notes is required")
      return;
    }
    else if (psiComments.length > 500) {
      setCommentsError("Notes must not exceed 500 characters")
      return;
    }

    // const dropDown = option == "" ? valueOption :  option;
    // const inputPsi = psiComments == "" ? valuePsi : psiComments;  

    const recentlyAddednewvalue = psiComments
    const recentOption = option

    setNotesList([recentlyAddednewvalue, recentOption])
    props.EditPsi(recentlyAddednewvalue)
    props.addDropdown(recentOption)
    props.addPSIValue(psiComments)
    props.addOption(option)

    // setComments(" ")
    // setTogglePopupOpen(false)
    console.log("option======", option)
    console.log("psiComments======", psiComments)
    console.log("recentlyAddednewvalue item======", recentlyAddednewvalue)

    // console.log("dropDown======",dropDown)
    // console.log("inputPsi======",inputPsi)

    // setValue(inputPsi)
    // setDrop(dropDown)

    ls.set('psiComments', psiComments);
    ls.set('option', option);

    //    ls.set('inputPsi', inputPsi);
    //    ls.set('dropDown', dropDown);

  }
  const getPsiDetails = () => {
    let request = {
      bill_of_sale_id: props.bosId,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    API.post("poschargeamount/condition", request).then((response) => {
      console.log("poschargeamount", response.data?.data);
      setDrop(response.data.data[0]);
      setIfComments(response.data.data[0].charge_amount);
      setOption(response.data.data[0].psi);
    });
  };
  useEffect(() => {
    getPsiDetails();
  }, []);

  return (
    <Modal show={togglePopupOpen} onHide={props.toggle} centered>
      <Modal.Header className="Terms-login">
        <Modal.Title>View Post Sale Inspection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3 className='viewpsiheading'>View Post Sale Inspection</h3>
        <label for="buyer" className="form-label">Is post sale required?</label>
        <select
          className="form-select"
          onChange={(e) => setOption(e.target.value)}
          disabled
        >
          <option style={{ display: "none" }}>{option}</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <label for="buyer" className="form-label">Post Sale Inspection</label>
        <InputGroup>
          <span class="input-group-text">$</span>
          <input
            className="form-control"
            type="text"
            placeholder=""
            aria-label="default input example"
            defaultValue={psiComments == null ? 0 : psiComments}
            onChange={(e) => setIfComments(e.target.value)}
            disabled
          />
        </InputGroup>
        <div className="Sellernotes">
                    <Button className="cta-btn" onClick={props.toggle}>Close</Button>
                </div>

      </Modal.Body>
    
      {isCommonPopupOpen &&
        <CommonPopup
          handleClose={isCommonPopupOpen}
          popupTitle={popupTitle}
          popupMsg={popupMsg}
          popupType={popupType}
          popupActionType={popupActionType}
          popupActionValue={popupActionValue}
          popupActionPath={popupActionPath}
        />
      }
    </Modal>
  );
}

export default ViewPSi;